import { render, staticRenderFns } from "./EarthIcon.vue?vue&type=template&id=1c10c9b3&scoped=true"
import script from "./EarthIcon.vue?vue&type=script&lang=ts"
export * from "./EarthIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c10c9b3",
  null
  
)

export default component.exports